export default __webpack_public_path__ + "static/media/excellIcon.bbc1130c.svg";